import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreBreadcrumbItem } from "@slhuicore/breadcrumb-item";

import { style } from "./assets/breadcrumb-item.generated-style";

/**
 * Linkable item which can be used as breadcrumb link
 *
 * @CustomElement slh-breadcrumb-item
 *
 * @cssprop --slh-default-font-family - Breadcrumb item font family.
 * @cssprop --slh-base-semi-bold-font-weight - Items font weight.
 * @cssprop --slh-base-xxs-line-height - Items line height.
 * @cssprop --slh-base-xxs-font-size - Items font size.
 * @cssprop --slh-color-outline - Items color. Focused element on tab border color.
 * @cssprop --slh-default-font-family - Separator font family.
 * @cssprop --slh-color-neutral-shade-60 - Separator color.
 * @cssprop --slh-base-semi-bold-font-weight - Separator font weight.
 * @cssprop --slh-base-xs-font-size - Separator font size.
 * @cssprop --slh-base-xxs-line-height - Separator line height.
 *
 * @slot icon - slh-icon element.
 * @slot title - Breadcrumb title.
 * @slot href - Breadcrumb link.
 *
 */
@customElement("slh-breadcrumb-item")
export default class SlhBreadcrumbItem extends SlhCoreBreadcrumbItem(
  LitElement
) {
  static styles = style;
}
